import React, {useEffect,useState} from 'react';
import {FormControl , TextField, Grid ,  Card, CardContent , Box, CardActions,Button,MenuItem,InputLabel,Select } from '@mui/material/';
import axios from 'axios';
import Cookies from 'js-cookie'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import DialogYesNo from '../lib/dialog_yes_no';


//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function MeetingScheduleEdit({secteur,clubid,meetId,callback}) {


    const [openQuestion, setOpenQuestion] = React.useState(false);

 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })

    const [autorize, setAutorize] = useState("false");
    const [MeetingAdresses, setMeetingAdresses] = React.useState([]);
    

    const [state, setState] = React.useState({
        addressId:"",
        editmode: "",          
        meetingTable:{id: meetId ,fk_club_master :clubid , fk_address_club :"" ,weekday  :"",  meet_time :"",freq :""   },      
    });


    useEffect(() => {

       
        if(meetId !== "new") 
           updateDisplay(meetId);


           MyAxios.get(process.env.REACT_APP_API + '/meetings/get/secteur/'+ secteur +'/club/'+ clubid +"/loadAdress" )
           .then((res) => {     
               setAutorize("true");               
               setMeetingAdresses(res.data);   
               //console.log(officerlist);                    
           })
           .catch((error) => {
               setAutorize("false");  
           });
           

    },[meetId] );



  function updateDisplay(meetId) { 
        if(meetId !== "")
        { 
                MyAxios.get(process.env.REACT_APP_API + '/meetings/get/secteur/'+ secteur +'/club/'+ clubid+'/meetingid/'+ meetId)
                .then((res) => {     
            
                    console.log("load edit row ------"+ res.data);
                    setState({ ...state, meetingTable: res.data[0]});
                                    
                })
                .catch((error) => {
                    console.log("ERROR load id "+meetId+" ------>" + error);
                });
        }
    }
    

    
    function onCloseDialog() {
        setOpenQuestion(false);
    }
    function DeleteMeetingModal() {       
        setOpenQuestion(true);      
    }

    
    function DeleteMeeting(response)
    {
     
        if(response === true)
        {
            if(meetId != undefined)
            {
               
                MyAxios.get(process.env.REACT_APP_API + '/meetings/secteur/'+ secteur +'/club/'+ clubid+'/delete/' + meetId )          
                .then((res) => {       
                        console.log(res)
                        if(res.status === 200)    
                        {
                            alert("Sauvegarde complété")
                            callback();
                        }   
                        else      
                            alert("Erreur sauvegarde") 
                        
                    })
                    .catch((error) => {
                        console.log(error)
                        alert("Erreur sauvegarde")
                    });
            }

        }

    }


  function SaveChange() { 


    if(meetId === "new")  
    {
        MyAxios.post(process.env.REACT_APP_API + '/meetings/secteur/'+ secteur +'/club/'+ clubid+'/add/' + clubid ,state.meetingTable)              
        .then((res) => {       
                console.log(res)
                if(res.status === 200)    
                    alert("Sauvegarde complété")
                else      
                    alert("Erreur sauvegarde") 
                
            })
            .catch((error) => {
                console.log(error)
                alert("Erreur sauvegarde")
            });
    }
    else
    {
        MyAxios.post(process.env.REACT_APP_API + '/meetings/secteur/'+ secteur +'/club/'+ clubid+'/update/'+ meetId,state.meetingTable)    
        .then((res) => {       
            console.log(res)
            if(res.status === 200)    
                alert("Sauvegarde complété")
            else      
                alert("Erreur sauvegarde") 
            
        })
        .catch((error) => {
            console.log(error)
            alert("Erreur sauvegarde")
        });
    }
}

       
    function handleChangeMeetingTable(event) {
         const value = event.target.value;
         console.log(event.target.id);
         let items = state.meetingTable;
         items[event.target.id] = value;
         setState({
           ...state, "meetingTable"  : items,
         });
    }

    
   function handleChangeSelectWeekDay(event) {
    const value = event.target.value;
    let items = state.meetingTable;
    items["weekday"] = value;
    setState({
      ...state, "meetingTable"  : items,
    });
  }

  
  function handleChangeSelectFreq(event) {
    const value = event.target.value;
    let items = state.meetingTable;
    items["freq"] = value;
    setState({
      ...state, "meetingTable"  : items,
    });
  }
  
  
  function handleChangeSelectAdresse(event) {
  
    const value = event.target.value; 
    let items = state.meetingTable;
    items["fk_address_club"] = value;
    setState({
      ...state, "meetingTable"  : items,
    });
  }

  

  function setValueTimeMeet(newValue) {
   // const value = event.target.value;
   console.log(newValue);


   let hours = newValue["$H"];
   if(hours <= 9)
      hours = "0" + "" + String(hours);

    let minutes = newValue["$m"];
      if(minutes <= 9 )
         minutes = "0" + "" + String(minutes);

    console.log(hours + ":" + minutes);
    let items = state.meetingTable;
    items["meet_time"] = "2023-01-01 " + hours + ":" + minutes;
    setState({
      ...state, "meetingTable"  : items,
    });
  }

  

  



    return (
        <div>
            <Box  sx={{display: 'flex', flexDirection: 'row' }} >
                 
            <Grid container  spacing={2}> 
                <Grid container direction="row" spacing={2}>                     
                                                                                  
                    
                        <Grid item xs={3} > 
                        <FormControl sx={{ m: 1, minWidth: 220 }}>
                            <InputLabel id="TitleLabel">Jour de réunion</InputLabel>
                            <Select
                            labelId="TitleLabel"
                            id="TitleReunion"
                            value={state.meetingTable.weekday}
                            label="Jour de réunion"
                            onChange={handleChangeSelectWeekDay}
                            >
                                <MenuItem key={"name-sharedMNullDay" } value=""></MenuItem>
                                <MenuItem key={"name-sharedLundi" } value="Lundi">Lundi</MenuItem>
                                <MenuItem key={"name-sharedMardi"} value="Mardi">Mardi</MenuItem>
                                <MenuItem key={"name-sharedMercredi"} value="Mercredi">Mercredi</MenuItem>
                                <MenuItem key={"name-sharedJeudi"} value="Jeudi">Jeudi</MenuItem>
                                <MenuItem key={"name-sharedVendredi"} value="Vendredi">Vendredi</MenuItem>
                                <MenuItem key={"name-sharedSamedi"} value="Samedi">Samedi</MenuItem>
                                <MenuItem key={"name-sharedDimanche"} value="Dimanche">Dimanche</MenuItem>
                            
                            </Select>
                        </FormControl>
                        </Grid> 


                        <Grid item xs={3} > 
                        <FormControl sx={{ m: 1, minWidth: 220 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                    label="Heure de réunion"
                                    value={state.meetingTable.meet_time}
                                    ampm={false}
                                    onChange={(newValue) => {
                                    setValueTimeMeet(newValue);
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>


                        <Grid item xs={3} > 
                        <FormControl sx={{ m: 1, minWidth: 220 }}>
                            <InputLabel id="TitleLabelfreq">Fréquence de réunion</InputLabel>
                            <Select
                            labelId="TitleLabel"
                            id="TitleFreqReunion"
                            value={state.meetingTable.freq}
                            label="Fréquence de réunion"
                            onChange={handleChangeSelectFreq}
                            >
                                <MenuItem key={"name-sharedMNullFreq" } value=""></MenuItem>
                                <MenuItem key={"name-sharedHebdomadaire" } value="Hebdomadaire">Hebdomadaire</MenuItem>
                                <MenuItem key={"name-sharedBimensuel"} value="Bimensuel">Bimensuel</MenuItem>
                                <MenuItem key={"name-sharedMensuel"} value="Mensuel">Mensuel</MenuItem>
                                <MenuItem key={"name-sharedTrimestriel"} value="Trimestriel">Trimestriel</MenuItem>
                                <MenuItem key={"name-sharedBimestriel"} value="Bimestriel">Bimestriel</MenuItem>
                                
                            
                            </Select>
                        </FormControl>
                        </Grid> 



                </Grid>


                <Grid container direction="row" spacing={2}> 
                        <Grid item xs={9} > 
                        <FormControl sx={{ m: 1, minWidth: 220 }}>
                            <InputLabel id="TitleLabelAdresse">Adresse</InputLabel>
                            <Select
                            labelId="TitleLabel"
                            id="TitleAdresseReunion"
                            value={state.meetingTable.fk_address_club}
                            label="Fréquence de réunion"
                            onChange={handleChangeSelectAdresse}
                            >

                             <MenuItem key={"name-sharedMNullAddressloc" } value=""></MenuItem>
                            {Object.entries(MeetingAdresses).map(([key, value]) => (
                                <MenuItem key={"name-sharedMNullAddress" + value.id } value={value.id} > {value.Address_To} {value.Address1}</MenuItem>
                            ))}
                            
                            </Select>
                        </FormControl>
                        </Grid> 
                     </Grid> 



                    <Grid container direction="row" spacing={2}> 
                        <Grid item xs={3} > 
                        <Button onClick={SaveChange} variant="containedFifth">ENREGISTRER</Button>                        
                        <Button onClick={DeleteMeetingModal} variant="containedFifth"  sx={{ m: 2 }}>SUPPRIMER</Button>
                        </Grid > 
                    </Grid>    
                    </Grid>
           </Box>

           <DialogYesNo question="Voulez-vous vraiment supprimer cette réunion?" onAnswer={DeleteMeeting} open={openQuestion} onClose={onCloseDialog}  />

           </div>
       
    );    
}


export default MeetingScheduleEdit;